/**
 *  update by tannc 2018年12月24日20:33:50
 */

import {
  USER_LIST_API,
  USER_SAVE_API,
  USER_UPDATE_API,
  USER_ENABLE_API,
  USER_DISABLE_API,
  USER_RESET_API,
  USER_ROLE_LIST_API
} from '../resource/index';
import axios from '../config/axios.config';
export default {

  async listUser(params){
    return await  axios.get(USER_LIST_API,params);
  },
  async saveUser(data){
    return await  axios.save(USER_SAVE_API,{},data);
  },
  async updateUser(id,data){
    return await  axios.save(USER_UPDATE_API,{id:id},data);
  },
  async enabledUser(id){
    return await  axios.save(USER_ENABLE_API,{id:id},{});
  },
  async disableUser(id){
    return await axios.save(USER_DISABLE_API,{id:id},{});
  },
  async resetPWD(id){
    return await axios.save(USER_RESET_API,{id:id},{});
  },
  async listUserRole(){
    return await  axios.get(USER_ROLE_LIST_API,{});
  },
}



// WEBPACK FOOTER //
// ./src/service/sysService.js